export const enumValueError = {
    UNRECOGNIZED_NIVEAU_LANGUE : "Niveau de langue non reconnu",
}